export default "__VITE_ASSET__Bh48Mu1b__"